var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-copy"},[_c('button',{staticClass:"btn",class:{'disable' : _vm.disable},attrs:{"type":"button"}},[_c('IconCopy',{attrs:{"width":"25px","height":"25px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }